// @flow

import React from 'react';
import { NavLink as RouterLink } from 'react-router-dom';

import LocaleCode from '../../providers/LocaleCode';

type Props = {
  to: string,
  children?: any,
};

const Link = (props: Props) => (
  <LocaleCode>
    {(localeCode: string) => (
      <RouterLink
        {...props}
        onClick={() =>
          window.scroll({
            behavior: 'smooth',
            top: 0,
          })
        }
        to={`/${localeCode}${props.to}`}
      >
        {props.children}
      </RouterLink>
    )}
  </LocaleCode>
);

export default Link;
